<nz-layout>
    <nz-content>
        <nz-table data-cy="cy-table-customer-rxs" #dynamicTable [nzData]="tableData" [nzLoading]="isLoading"
            [nzPageSize]="5000" [nzShowPagination]="false">
            <thead>
                <tr>
                    <th [rowspan]="1" nzShowExpand></th>
                    <th>Prescriber</th>
                    <th>Created At</th>
                    <th>
                        <span style="font-size: x-small">Last Fulfillment</span><br />Created At
                    </th>
                    <th>
                        <span style="font-size: x-small">Last Fulfillment</span><br />Order #
                    </th>
                    <th>Print Count</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <ng-template ngFor let-data let-i="index" [ngForOf]="dynamicTable.data">
                    <!-- <ng-template *ngFor="let data of tableData"> -->
                    <tr>
                        <td nzShowExpand [(nzExpand)]="data.expand"></td>
                        <td>
                            {{
                            asAdminUser(data.createdBy)?.firstName +
                            ' ' +
                            asAdminUser(data.createdBy)?.lastName
                            }}
                        </td>
                        <td>
                            {{ data.createdAt | date : 'MMM d yyyy @ h:mm a' }}
                        </td>

                        <td>
                            {{
                            data.lastFulfill.createdAt
                            | date : 'MMM d yyyy @ h:mm a'
                            }}
                        </td>
                        <td>
                            <a (click)="
                                    openOrderDetails(data.lastFulfill.orderId)
                                ">
                                {{ data.lastFulfill.orderId }}
                            </a>
                        </td>
                        <td>
                            {{ data.printCounter }}
                        </td>

                        <td class="text-center" [colSpan]="2">
                            <ng-container *ngIf="isLoading; else readyTemplate">
                                <i nz-icon nzType="loading" nzTheme="outline"></i>
                            </ng-container>
                            <ng-template #readyTemplate>
                                <span *ngIf="!!data.voidedAt" style="color: orange">Voided:
                                    {{
                                    data.voidedAt
                                    | date : 'MMM d yyyy @ h:mm a'
                                    }}
                                </span>
                                <span *ngIf="!!data.transferredOutAt" style="color: #1677ff">
                                    Transferred Out:
                                    {{
                                    data.transferredOutAt
                                    | date : 'MMM d yyyy @ h:mm a'
                                    }}
                                </span>
                                <button *ngIf="!data.voidedAt" nz-popconfirm
                                    nzPopconfirmTitle="This action will count as a print and will increase the print count for this RX?"
                                    (nzOnConfirm)="viewRx(data)" nz-button nzType="link" nz-tooltip
                                    nzTooltipTitle="View RX">
                                    <i class="fa-solid fa-eye pointer"></i>
                                </button>
                                <nz-divider *ngIf="!data.voidedAt" nzType="vertical"></nz-divider>

                                <button *ngIf="!data.voidedAt && !data.transferredOutAt" nz-button nzType="link"
                                    (click)="transferRx(data)" [disabled]="sendingPdfToChat.has(data._id)" nz-tooltip
                                    nzTooltipTitle="Transfer RX">
                                    <i *ngIf="!sendingPdfToChat.has(data._id)" class="fa-solid fa-file-export pointer"></i>
                                    <i *ngIf="sendingPdfToChat.has(data._id)" class="fa-solid fa-spinner fa-spin"></i>
                                </button>
                                <nz-divider *ngIf="!data.voidedAt" nzType="vertical"></nz-divider>

                                <button *ngIf="!data.voidedAt" href="javascript:void(0)" (click)="sendRx(data._id)"
                                    nz-button nzType="link"
                                    [disabled]="isOnCooldown(data._id) || !!data.transferredOutAt" nz-tooltip
                                    nzTooltipTitle="Fax RX">
                                    <i class="fa-solid fa-paper-plane pointer"></i>
                                </button>
                                <nz-divider *ngIf="!data.voidedAt" nzType="vertical"></nz-divider>
                                <button *ngIf="!data.voidedAt" href="javascript:void(0)" (click)="openFulfillment(data)"
                                    nz-button nzType="link" [disabled]="!!data.transferredOutAt" nz-tooltip
                                    nzTooltipTitle="Fulfill Order">
                                    <i class="fa-solid fa-pills"></i>
                                </button>
                                <nz-divider *ngIf="!data.voidedAt" nzType="vertical"></nz-divider>

                                <button *ngIf="!data.voidedAt" [attr.data-cy]="'cy-i-edit-rx' + i" nz-button
                                    nzType="link" nz-tooltip nzTooltipTitle="Edit" [disabled]="
                                        data.printCounter > 0 ||
                                        !!data.voidedAt ||
                                        !!data.transferredOutAt
                                    " (click)="openEditRx(data)">
                                    <i class="fa-solid fa-pen"></i>
                                </button>

                                <nz-divider nzType="vertical"></nz-divider>

                                <button *ngIf="!data.voidedAt" nz-button nzType="link" nz-tooltip
                                    nzTooltipTitle="Duplicate" [disabled]="!!data.transferredOutAt"
                                    (click)="openDuplicateRx(data)">
                                    <i class="fa-solid fa-clone"></i>
                                </button>

                                <nz-divider *ngIf="!data.voidedAt" nzType="vertical"></nz-divider>

                                <button *ngIf="!data.voidedAt" nz-button nzType="link" nz-tooltip nzDanger
                                    nzTooltipTitle="Void" nz-popconfirm [nzPopconfirmTitle]="
                                        'Please confirm you want to void this RX?'
                                    " nzPopconfirmPlacement="bottom" (nzOnConfirm)="voidRx(data._id)">
                                    <i class="fas fa-file-excel"></i>
                                </button>
                            </ng-template>
                        </td>
                    </tr>
                    <tr [nzExpand]="data.expand">
                        <div class="drugs-container">
                            <nz-table style="margin: 10px" [nzData]="data.drugs" [nzShowPagination]="false">
                                <thead>
                                    <tr>
                                        <th>Drugs</th>
                                        <th>DIN</th>
                                        <th [colspan]="9">Sig</th>
                                        <th>Mitte</th>
                                        <th>Refills</th>
                                    </tr>
                                </thead>

            <tbody>
                <tr *ngFor="let drug of data.drugs">
                    <td>{{ drug.drugName }}</td>
                    <td>
                        <a (click)="onDrugClick(drug)">
                            {{ drug.din }}
                        </a>
                    </td>
                    <td [colSpan]="9">
                        {{ drug.notes }}
                    </td>
                    <td>{{ drug.mitte }}</td>
                    <td>{{ drug.refills }}</td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <td [attr.colSpan]="13" class="note-cell">
                        {{ data.notes }}
                    </td>
                </tr>
            </tfoot>
        </nz-table>
        </div>
        </tr>
        </ng-template>
        </tbody>
        </nz-table>
    </nz-content>
</nz-layout>